import { request as getRequest } from './reducers/get';
import { request as moveList } from './reducers/move-list';

// eslint-disable-next-line import/no-default-export
export default {
    SPORTS_GET_REQUEST: getRequest,
    SPORTS_LIST_MOVE_REQUEST: moveList,
};
